// Helper unifié pour fire un event Meta (client + CAPI server-side, dédupliqués)
// Usage : await fireMetaEvent({ event_name: "CompleteRegistration", email, external_id: userId })

type FireOpts = {
  event_name:
    | "PageView"
    | "ViewContent"
    | "Lead"
    | "CompleteRegistration"
    | "InitiateCheckout"
    | "Subscribe"
    | "Purchase"
    | "ActivatedUser"
  email?: string | null
  phone?: string | null
  first_name?: string | null
  last_name?: string | null
  external_id?: string | number | null
  value?: number
  currency?: string
  event_id?: string
  custom_data?: Record<string, unknown>
}

function getCookie(name: string): string {
  if (typeof document === "undefined") return ""
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`))
  return m ? m[1] : ""
}

function getFbc(): string {
  const cookieFbc = getCookie("_fbc")
  if (cookieFbc) return cookieFbc
  if (typeof window === "undefined") return ""
  const fbclid =
    new URLSearchParams(window.location.search).get("fbclid") ||
    localStorage.getItem("fbclid") ||
    ""
  if (fbclid) {
    localStorage.setItem("fbclid", fbclid)
    return `fb.1.${Date.now()}.${fbclid}`
  }
  return ""
}

function genEventId(name: string): string {
  return `${name.toLowerCase()}_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`
}

export async function fireMetaEvent(opts: FireOpts): Promise<void> {
  if (typeof window === "undefined") return
  const event_id = opts.event_id || genEventId(opts.event_name)
  const fbp = getCookie("_fbp")
  const fbc = getFbc()
  const page_url = window.location.href

  // 1. Client-side pixel (déduplication via event_id)
  try {
    const w = window as unknown as {
      fbq?: (...args: unknown[]) => void
      dataLayer?: unknown[]
    }
    const params: Record<string, unknown> = {}
    if (opts.value !== undefined) params.value = opts.value
    if (opts.currency) params.currency = opts.currency
    if (opts.custom_data) Object.assign(params, opts.custom_data)

    const isCustom = opts.event_name === "ActivatedUser"
    if (typeof w.fbq === "function") {
      w.fbq(isCustom ? "trackCustom" : "track", opts.event_name, params, { eventID: event_id })
    }
    if (Array.isArray(w.dataLayer)) {
      w.dataLayer.push({ event: `fb_${opts.event_name}`, event_id, ...params })
    }
  } catch {}

  // 2. Server-side CAPI (toujours, doublé du client pour bypass adblockers)
  try {
    await fetch("/api/meta/event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        event_name: opts.event_name,
        email: opts.email || undefined,
        phone: opts.phone || undefined,
        first_name: opts.first_name || undefined,
        last_name: opts.last_name || undefined,
        external_id: opts.external_id ? String(opts.external_id) : undefined,
        value: opts.value,
        currency: opts.currency,
        event_id,
        fbp,
        fbc,
        page_url,
        custom_data: opts.custom_data,
      }),
    })
  } catch {}
}
